module.exports = __webpack_public_path__ + "static/media/mistenksom.3b3434ab.m4a";